import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import warning_icon from '../../assets/images/warning_icon.svg';

const DDConfirmationPopup = ({
  show,
  onHide,
  onConfirm,
  payrollHeaderId,
  company
}) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // Get the specific payroll being confirmed
  const selectedPayroll = company?.payrolls?.find(
    (p) => p.payrollHeaderId === payrollHeaderId
  );

  // Calculate total and employee count for ONLY the selected payroll
  const total = selectedPayroll?.employees?.reduce(
    (sum, emp) => sum + (emp.netPayAfterWH || 0),
    0
  ) || 0;

  const employeeCount = selectedPayroll?.employees?.length || 0;

  const formatMoney = (v) =>
    v !== null && v !== undefined
      ? `${Number(v).toLocaleString()}`
      : '-';

  const handleConfirm = async () => {
    if (!onConfirm || !payrollHeaderId) return;

    setLoading(true);
    setSuccess(false);

    try {
      const response = await onConfirm(payrollHeaderId);

      if (response?.success === true) {
        onHide();
        setSuccess(true);
      } else {
        throw new Error("Direct deposit failed");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* CONFIRM MODAL */}
      <Modal show={show} onHide={onHide} centered className="companys_payroll_popup">
        <Modal.Body>
          <div className="dd_counfirm_popup text-center pt-4">
            <img src={warning_icon} alt="Warning" className="mb_20" />
            <h6 className="my_10">Confirm DD Payment</h6>
            <p>
              DD for {company?.companyName} –{' '}
              {employeeCount} employees – Total ${formatMoney(total)}
            </p>

            <Form className="mt_20 text-start">
              <Form.Check
                type="checkbox"
                id="custom-checkbox"
                label="I have reviewed the details and confirm this payment."
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer className="text-center d-flex justify-content-center">
          <Button variant="secondary" onClick={onHide} className="btn_cancel my-0">
            Cancel
          </Button>

          <Button
            variant="primary"
            className="btn_primary my-0 border-0"
            disabled={!checked || loading}
            onClick={handleConfirm}
          >
            {loading ? 'Processing' : 'Confirm & Pay'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DDConfirmationPopup;
